import React from 'react';
import { VirtualizedMultiSelectCombobox } from '@roger/ui-components';
import {
  getAgencyClinicDisplayName,
  type AgencyClinicDisplayInput,
} from '../../utils/agencyClinicDisplayName';
import type { ClinicSelectClinic } from './ClinicSelect';

type MultiSelectProps = React.ComponentProps<
  typeof VirtualizedMultiSelectCombobox
>;

export interface ClinicMultiSelectProps extends Omit<
  MultiSelectProps,
  'options' | 'renderOption'
> {
  clinics: ClinicSelectClinic[];
  agencyName?: string | null;
}

/**
 * Multi-select clinic filter.
 */
export function ClinicMultiSelect({
  clinics,
  agencyName,
  ...rest
}: ClinicMultiSelectProps) {
  const options = React.useMemo(() => {
    const totalClinicCount = clinics.length;
    return clinics.map(clinic => ({
      value: clinic.id,
      label: getAgencyClinicDisplayName(clinic as AgencyClinicDisplayInput, {
        agencyName,
        totalClinicCount,
      }),
    }));
  }, [clinics, agencyName]);

  return <VirtualizedMultiSelectCombobox options={options} {...rest} />;
}
